// Shared content & assets for Koreko Direct
export const BRAND = {
  name: "Koreko Direct",
  slogan: "Eleganza · Semplicità · Innovazione",
  tagline: "Innovazione e Qualità per i Tuoi Spazi",
  phone: "+39 347 165 1098",
  phoneClean: "393471651098",
  email: "korekodirect@gmail.com",
  address: "Lungomare G. Caboto, 74 — Gaeta (LT)",
  region: "Lazio · Italia",
  whatsapp: "https://wa.me/393471651098",
  logo: "https://customer-assets.emergentagent.com/job_gifted-carson-6/artifacts/xh2xr3oy_koreko%20direct%20logo%20per%20sito%20%281%29.png",
};

export const BROCHURES = {
  win_box: {
    title: "Catalogo Win Box",
    desc: "Linea PVC · Win · Win Slide · Lumen",
    url: "/uploads/pdfs/2026/07/a9c11b65596a82d446c63baa.pdf",
  },
  fiber: {
    title: "Catalogo Fiber & FiberK Slim",
    desc: "Linea PVC e PVC/Alluminio",
    url: "/uploads/pdfs/2026/07/78870c47b0d5a7b6ecb85d4d.pdf",
  },
  alluminio: {
    title: "Brochure Alluminio",
    desc: "New Termic EVO · Air Slide · SkyWood EVO",
    url: "/uploads/pdfs/2026/07/07e41b1d2e393086e7d8f943.pdf",
  },
};

export const IMAGES = {
  hero_glass: "https://static.prod-images.emergentagent.com/jobs/40c756d6-41ef-40e2-a4f5-ab84cce35029/images/03a0b185e04436bdf7ed70023e5d5a7029238a843305c3d09a61bcd5676d1670.png",
  hero_interior: "https://static.prod-images.emergentagent.com/jobs/40c756d6-41ef-40e2-a4f5-ab84cce35029/images/e9460317ce21a04339425bc72656e4c7703c0720109c4384a1c1f49384884c9f.png",
  detail_aluminum: "https://static.prod-images.emergentagent.com/jobs/40c756d6-41ef-40e2-a4f5-ab84cce35029/images/9ad82dc6faccb79ae0bb8bc434fe814298d9c628b348df6f8c9434003d1ef668.png",
  pergola_1: "https://images.pexels.com/photos/33993508/pexels-photo-33993508.jpeg",
  pergola_2: "https://images.unsplash.com/photo-1762608675427-09ac2dbd1540?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxiaW9jbGltYXRpYyUyMHBlcmdvbGElMjBvdXRkb29yJTIwcGF0aW98ZW58MHx8fHwxNzc5MzgwMTYyfDA&ixlib=rb-4.1.0&q=85",
  interior_minimalist: "https://images.unsplash.com/photo-1759692071732-9ba8ac519f1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBtaW5pbWFsaXN0JTIwd2luZG93JTIwaW50ZXJpb3IlMjBsaWdodHxlbnwwfHx8fDE3NzkzODAxNjJ8MA&ixlib=rb-4.1.0&q=85",
  solar: "https://images.unsplash.com/photo-1767429168282-dc38970e8d3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxzb2xhciUyMHBhbmVscyUyMG1vZGVybiUyMGhvdXNlfGVufDB8fHx8MTc3OTM4MDE2Mnww&ixlib=rb-4.1.0&q=85",
  // Product-specific images
  pvc_alluminio: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=80",
  alluminio: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80",
  alluminio_legno: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1600&q=80",
  vetrate_panoramiche: "https://images.unsplash.com/photo-1600210492493-0946911123ea?auto=format&fit=crop&w=1600&q=80",
  // KORUS official imagery from manufacturer
  korus_winbox: "https://customer-assets.emergentagent.com/job_gifted-carson-6/artifacts/f091zlxw_nuovo%2Bwin%2Bbox%2Bslim-1920w.webp",
  korus_nodo: "https://lirp.cdn-website.com/fde26adf/dms3rep/multi/opt/Nuovo+nodo+centrale-1920w.jpg",
  korus_fiberk: "https://lirp.cdn-website.com/fde26adf/dms3rep/multi/opt/FIBERK_Ambientata_gybzhm-c432d123-1920w.png",
  korus_lumen: "https://lirp.cdn-website.com/fde26adf/dms3rep/multi/opt/lumen_desk1-08fb5454-1920w.jpg",
  korus_newtermic: "https://lirp.cdn-website.com/fde26adf/dms3rep/multi/opt/NewTermic_linear_amb_interna_r8iu7d-8d23017c-1920w.png",
  korus_skywood: "https://lirp.cdn-website.com/fde26adf/dms3rep/multi/opt/skywood-1920w.jpg",
  korus_airslide: "https://lirp.cdn-website.com/fde26adf/dms3rep/multi/opt/air-slide-legno-d2dbd993-1920w.jpg",
  korus_aluwood: "https://lirp.cdn-website.com/fde26adf/dms3rep/multi/opt/AluWood_minimale_amb_interna_2mod_cuphtc-08257b14-1920w.png",
  korus_logo: "https://lirp.cdn-website.com/fde26adf/dms3rep/multi/opt/Logo-Korus-Bianco_jpg-1920w.jpg",
};

export const CATEGORIES = [
  {
    slug: "infissi",
    overline: "01 — Serramenti",
    title: "Infissi su misura",
    desc: "PVC, alluminio, alluminio/legno. Tecnologia tedesca, design italiano. Massima efficienza termica e acustica per ogni ambiente.",
    image: IMAGES.detail_aluminum,
    items: ["Win · Win Slide", "Lumen · Fiber Slim", "New Termic EVO", "SkyWood EVO · Air Slide"],
  },
  {
    slug: "vetrate",
    overline: "02 — Trasparenze",
    title: "Vetrate panoramiche & a pacchetto",
    desc: "Pareti vetrate scorrevoli, impacchettabili e a tutta altezza. Trasformiamo il limite tra interno ed esterno in un gesto fluido.",
    image: IMAGES.hero_glass,
    items: ["Vetrate scorrevoli", "Vetrate a pacchetto", "Pareti panoramiche"],
  },
  {
    slug: "pergole",
    overline: "03 — Outdoor",
    title: "Pergole bioclimatiche & pergotende",
    desc: "Vivi gli spazi esterni in ogni stagione. Lame orientabili, motorizzazioni silenziose, integrazione con illuminazione e riscaldamento.",
    image: IMAGES.pergola_1,
    items: ["Pergole bioclimatiche", "Pergotende", "Tende a bracci"],
  },
];

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/prodotti", label: "Prodotti" },
  { to: "/premi", label: "Premi" },
  { to: "/chi-siamo", label: "Chi Siamo" },
  { to: "/detrazioni-fiscali", label: "Detrazioni 50%" },
  { to: "/contatti", label: "Contatti" },
];
